import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { WhyBuildSection } from '../components/WhyBuildSection';
import { Top10Section } from '../components/Top10Section';
import { Top20Section } from '../components/Top20Section';
import { OpenProposalsSection } from '../components/OpenProposalsSection';
import { Footer } from '../components/Footer';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#02040A]" data-testid="landing-page">
      <Navbar />
      <HeroSection />
      <WhyBuildSection />
      <Top10Section />
      <Top20Section />
      <OpenProposalsSection />
      <Footer />
    </div>
  );
}
